import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import CountryCard from "./CountryCard";

const CardList = () => {
    const [countries, setCountries] = useState([]);
    const ref = useRef(null);

    useEffect(() => {
        axios.get('https://kyrgyz-adventure-travel.com/api/v1/tours/country-list')
            .then(r => setCountries(r.data.results))
            .catch(e => console.error(e));
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => entries.forEach(e => {
                if (e.isIntersecting) e.target.classList.add('visible');
            }),
            { threshold: 0.1 }
        );
        const els = ref.current?.querySelectorAll('.reveal');
        els?.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, [countries]);

    return (
        <div ref={ref} id="destinazioni" className="bg-dark-2 py-24 md:py-36">
            <div className="container">
                <div className="reveal flex flex-col items-center gap-4 mb-16 text-center">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-px bg-it-green opacity-90" />
                        <p className="font-unbounded text-white text-xs uppercase tracking-widest">Explore the world</p>
                        <div className="w-8 h-px bg-gold opacity-70" />
                    </div>
                    <h2 className="font-unbounded font-bold text-4xl md:text-5xl text-white">Destinations</h2>

                    <p className="font-manrope text-white/55 text-lg max-w-xl leading-relaxed mt-2">
                        Choose your ideal vacation in Central Asia and set off on a unique adventure.
                    </p>
                </div>

                <div className="flex flex-wrap gap-6 justify-center">
                    {countries.map((country, i) => (
                        <div key={country.id} className="reveal w-full sm:w-[calc(33.333%-16px)]"
                             style={{ transitionDelay: `${i * 0.1}s` }}>
                            <CountryCard country={country} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CardList;
